import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AttachmentService {
    private readonly _http = inject(HttpClient);

    public get(attachmentId: string): Observable<Blob> {
        return this._http.get(`/api/attachment/${attachmentId}/stream`, {
            responseType: 'blob' 
        });
    }
}
